module.exports = __webpack_public_path__ + "static/media/orders.7f94b123.jpg";